export const paths = {
  home: '/',
  auth: {
    login: '/auth/login',
    signup: '/auth/signup',
    verifyEmail: '/auth/verify-email',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    changePassword: '/change-password',
    checkEmail: '/auth/check-email',
    emailVerified: '/auth/email-verified',
  },
  keywords: {
    // ! figure a way to make this dynamic
    _prefix: '/keywords',
    keySearch: '/keywords/keyword-research',
    quickDifficulty: '/keywords/quick-difficulty',
    brainstorm: '/keywords/brainstorm',
    deepDive: '/keywords/deep-dive',
    myLists: '/keywords/my-lists',
  },
  settings: {
    _prefix: '/settings',
    index: '/settings',
    logs: '/settings/logs',
    agencies: '/settings/team-management',
    billing: '/settings/billing',
  },
  admin: {
    _prefix: '/admin',
    users: '/admin/users',
    plans: '/admin/plans',
    claimableActions: '/admin/claimable-actions',
    inviteCampaigns: '/admin/invite-campaigns',
    upsellChains: '/admin/upsell-chains',
    gemApprovalSuccess: '/admin/gem-approval-success',
  },
  dashboard: {
    index: '/dashboard',
  },
  gemsMarketplace: '/gems-marketplace',
  contentAssistant: {
    _prefix: '/content-assistant',
    editor: '/content-assistant/editor',
    articles: '/content-assistant/articles',
    drafts: '/content-assistant/drafts',
    reader: (articleId: string) => `/content-assistant/articles/${articleId}`,
  },
  error: '/error',
  onboarding: '/onboarding',
  gsc: {
    _prefix: '/gsc',
    sites: {
      root: '/gsc/sites',
      details: (siteId: string) => `/gsc/sites/${siteId}`,
      advancedSearch: (siteId: string) =>
        `/gsc/sites/${siteId}/advanced-search`,
    },
    import: (account_id: string) => `/gsc/import?account_id=${account_id}`,
    accounts: '/gsc/accounts',
  },
  api: {
    callback: {
      resetPassword: '/api/callback/reset-password',
      agencyInvite: '/api/callback/agency-invite',
    },
    stripeCheckout: '/api/stripe/create-checkout-session',
  },
  agencyInvite: {
    error: '/agency-invite/error',
    limitReached: '/agency-invite/limit-reached',
  },
  rankTracker: {
    _prefix: '/rank-tracker',
    root: '/rank-tracker',
    details: (domainId: string) => `/rank-tracker/${domainId}`,
  },
  backlinks: {
    _prefix: '/backlinks',
    root: '/backlinks',
    overview: (domain: string) => `/backlinks/${domain}/overview`,
    backlinks: (domain: string) => `/backlinks/${domain}/backlinks`,
    topPages: (domain: string) => `/backlinks/${domain}/top-pages`,
    anchors: (domain: string) => `/backlinks/${domain}/anchors`,
    competitors: (domain: string) => `/backlinks/${domain}/competitors`,
  },
  siteAudit: {
    _prefix: '/site-audit',
  },
  siteStats: {
    _prefix: '/site-stats',
  },
  geogrid: {
    _prefix: '/geogrid',
    root: '/geogrid',
  },
  checkout: {
    index: '/checkout',
    success: '/checkout/success',
    cancel: '/checkout/cancel',
  },
  pricing: {
    feature: (feature: string) => `/pricing/${feature}`,
  },
  gbpAudit: {
    _prefix: '/gbp-audit',
    root: '/gbp-audit',
    details: (auditId: string) => `/gbp-audit/${auditId}`,
  },
  marketplace: {
    index: '/gems-marketplace',
  },
  publishing: {
    _prefix: '/publishing',
    sites: '/publishing/sites',
    wordpressUploader: '/publishing/wordpress-uploader',
    mediaManager: '/publishing/media-manager',
    aiGenerator: '/publishing/ai-generator',
    aiGeneratorV2: '/publishing/ai-generator-v2',
    textOverlay: '/publishing/text-overlay',
  },
} as const;
